import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class PanelSupportComponent extends Vue {
    formatPhone(phone: string) {
        // eslint-disable-next-line no-useless-escape
        return 'tel:' + phone.replace(/[ \-\(\)]/gi, '');
    }
    supportEvent() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.' + this.getPathForMetrik());
    }
    getPathForMetrik() {
        let currentPath = '';
        if (this.$router.currentRoute.path === '/account') {
            currentPath = 'account';
        } else if (this.$router.currentRoute.path.includes('order')) {
            currentPath = 'order';
        } else {
            currentPath = 'unknow';
        }
        return currentPath;
    }
}
